import { cx } from "@linaria/core";
import { CtaComponentCard } from "@courses-pm2/api";

import * as styles from "./atom.button.style";

type Props = {
  icon: CtaComponentCard["link"]["target"];
  theme: "black" | "accent";
};

export function CardButton(props: Props): React.JSX.Element {
  const icon = (() => {
    switch (props.icon) {
      case "download":
        return <DownloadIcon />;

      case "lightbox":
        return <OpenIcon />;

      case "new-tab":
        return <ExternalLinkIcon />;

      case "same-tab":
        return <ChevronIcon />;

      default:
        return null;
    }
  })();

  return (
    <div className={styles.buttonWrapper}>
      {icon && (
        <div
          className={cx(
            styles.button,
            props.theme === "accent" && styles.accentTheme,
          )}
        >
          {icon}
        </div>
      )}
    </div>
  );
}

function DownloadIcon(): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
      height="20"
      fill="none"
      strokeWidth="1.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M11 1v14.36M5.62 10.13 11 15.52l5.39-5.39M21 15.62v1.79c0 1.98-1.2 3.59-2.67 3.59H3.67C2.19 21 1 19.4 1 17.41v-1.8" />
    </svg>
  );
}

function OpenIcon(): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 23.5 23.5"
      xmlns="http://www.w3.org/2000/svg"
      height="20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m8.17 22.5h-7.17v-7.17m14.33-14.33h7.17v7.17" />
      <path d="m22.5 15.33v7.17h-7.17" />
      <path d="m1 8.17v-7.17h7.17" />
    </svg>
  );
}

function ExternalLinkIcon(): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
      height="20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 7V1h-6M21 1 7.67 14.33M10.33 5h-8A1.33 1.33 0 0 0 1 6.33v13.34A1.33 1.33 0 0 0 2.33 21h13.34A1.33 1.33 0 0 0 17 19.67v-8" />
    </svg>
  );
}

function ChevronIcon(): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 13 21"
      xmlns="http://www.w3.org/2000/svg"
      height="20"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      style={{
        marginLeft: "1px",
      }}
    >
      <path d="m1.9 19.8 9.2-9.3L2 1.2" />
    </svg>
  );
}
